import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { offerData, helpData, serviceArea1, serviceArea2 } from '../data/general';

const HighlightedBlock = () => (
  <div className="Footer-Highlighted">
    <Row>
      <Col md={3}>
        <h6 className="Footer-Highlighted__Title">Help &amp; Support</h6>
        <ul className="Footer-Highlighted__Nav">
          {
            helpData.map((data, index) => (
              <li key={index}>
                <Link to={'/' + data.slug}>
                  {data.name}
                </Link>
              </li>
            ))
          }
        </ul>
      </Col>
      <Col md={3}>
        <h6 className="Footer-Highlighted__Title">Offerings</h6>
        <ul className="Footer-Highlighted__Nav">
          {
            offerData.map((data, index) => (
              <li key={index}>
                <Link to={'/' + data.slug}>
                  {data.name}
                </Link>
              </li>
            ))
          }
        </ul>
      </Col>
      <Col md={6}>
        <Row>
          <Col xs={12}>
            <h6 className="Footer-Highlighted__Title">Area of Services</h6>
          </Col>
          <Col xs={12}>
            <Row>
              <Col md={6}>
                <ul className="Footer-Highlighted__Nav">
                  {
                    serviceArea1.map((data, index) => (
                      <li key={index}>
                        <Link to={'/' + data.slug}>
                          {data.name}
                        </Link>
                      </li>
                    ))
                  }
                </ul>
              </Col>
              <Col md={6}>
                <ul className="Footer-Highlighted__Nav">
                  {
                    serviceArea2.map((data, index) => (
                      <li key={index}>
                        <Link to={'/' + data.slug}>
                          {data.name}
                        </Link>
                      </li>
                    ))
                  }
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
);

export default HighlightedBlock;